
<!-- Header -->
<div class="row">
  <div class="col-12 dashboard-panel-header-flex-container">
    <span class="h6 lightgray-font">{{ title | translate}}</span>
    <div>
      <button class="btn btn-light dashboard-panel-button" (click)="onForceRefresh()" title="{{'i18n.domain.home.dashboard.shared.refresh-widget-data' | translate}}">
        <span class="icon-reset"></span>
      </button>
      <button class="btn btn-light dashboard-panel-button" (click)="onConfigure()" *ngIf="mode === WidgetMode.Edit || mode === WidgetMode.Preview">
        <span class="icon-settings"></span>
      </button>
      <button class="btn btn-light dashboard-panel-button" (click)="onDelete()" *ngIf="mode === WidgetMode.Edit">
        <span class="icon-trash-can" style="color:red"></span>
      </button>
    </div>
  </div>
</div>
<!-- Content -->
<div class="row" *ngIf="selectedClientDto !== null && selectedZoneIds?.length !== 0">
  <div class="col-12">
    <ejs-grid #grid
              rowHeight="38"
              class="grid grid-filter"
              [dataSource]="data"
              [allowSorting]="true"
              [allowPaging]="true"
              [pageSettings]='pageSettings'
              [allowFiltering]="true"
              [filterSettings]="filterSettings"
              [allowGrouping]='true'
              [groupSettings]='groupOptions'
              (actionBegin)="actionBegin($event)"
              (actionComplete)="actionComplete($event)"
              (created)="gridCreated()">
      <e-columns class="small-font">
        <e-column field="id" [visible]="false" [isPrimaryKey]="true"></e-column>
        <e-column field="{{ZONE_NAME_COLUMN_NAME}}"
                  uid="dcw-zone-name-{{panelId}}"
                  headerText="{{'i18n.domain.device-interaction.grid.zone' | translate}}"
                  clipMode="EllipsisWithTooltip"
                  type="string">
        </e-column>
        <e-column field="name"
                  uid="dcw-name-{{panelId}}"
                  headerText="{{'i18n.domain.device-interaction.grid.device' | translate}}"
                  clipMode="EllipsisWithTooltip"
                  type="string">
        </e-column>
        <e-column field="deviceType"
                  uid="dcw-deviceType-{{panelId}}"
                  headerText="{{'i18n.domain.device-interaction.grid.device-type' | translate}}"
                  clipMode="EllipsisWithTooltip"
                  type="string"
                  [filter]="typeFilter">
          <ng-template #filterItemTemplate let-data>{{formatType(data)}}</ng-template>
          <ng-template #template let-data>
            {{getDeviceType(data.deviceType) | translate}}
          </ng-template>
        </e-column>
        <e-column field="state"
                  uid="dcw-state-{{panelId}}"
                  headerText="{{'i18n.domain.device-interaction.grid.state' | translate}}"
                  clipMode="EllipsisWithTooltip"
                  type="string"
                  [filter]="stateFilter">
          <ng-template #filterItemTemplate let-data>{{formatState(data)}}</ng-template>
          <ng-template #template let-data>
            {{getDeviceState(data.state) | translate}}
          </ng-template>
        </e-column>
        <e-column field="stateIndicator"
                  uid="dcw-state-indicator-{{panelId}}"
                  headerText=""
                  width="60px"
                  [allowFiltering]="false"
                  [allowSorting]="false">
          <ng-template #template let-data>
            <div class="state-indicator-container">
              <span class="state-indicator-circle" [ngClass]="getStateClass(data.state)"></span>
            </div>
          </ng-template>
        </e-column>
      </e-columns>
    </ejs-grid>
  </div>
</div>
<div class="row" *ngIf="selectedClientDto === null || selectedZoneIds?.length === 0">
  <div class="col-12 text-center">
    <div appMessageDirective
         [variant]="MessageVariant.Standart"
         [severity]="MessageSeverity.AVPColors">
      {{'i18n.domain.home.dashboard.device-interaction-widget.no-client-selected' | translate}}
    </div>
  </div>
</div>

<ejs-dialog #widgetSettingsDialog
            class="dialog-min-height"
            [isModal]="true"
            [showCloseIcon]="true"
            (close)="onCloseSettingsDialog()"
            [visible]="false">
  <ng-template #header>
    {{'i18n.domain.home.dashboard.edit-settings-dialog-title' | translate}}
  </ng-template>
  <ng-template #content>
    <form [formGroup]="editSettingsForm" *ngIf="widgetSettingsDialog.visible">
      <div class="row">
        <div class="form-group col-12">
          <label class="control-label">{{'i18n.domain.home.dashboard.shared.widgets.title' | translate}}</label>
          <input id="title" type="text" class="form-control" formControlName="title" />
        </div>
      </div>
      <div class="row" >
        <div class="col-12">
          <label class="control-label required">{{'i18n.base.shared.client-dropdown.client' | translate}}</label>
          <app-client-autocomplete [(selectedClient)]="selectedClientDto" class="client-autocomplete me-2"></app-client-autocomplete>
        </div>
      </div>
      <div class="row">
        <div class="form-group col-12">
          <label class="control-label required">{{'i18n.domain.home.dashboard.device-interaction-widget.select-zones' | translate}}</label>
          <app-multi-select-filter #zoneMultiselect
                                   [getDataFunction]="searchZoneValues.bind(this)"
                                   [(values)]="selectedZoneIds"
                                   [type]="MultiSelectFilterType.MultiSelectItem"
                                   [isDisabled]="editSettingsForm.controls.selectedClient.value === null"
                                   placeholder="i18n.domain.reports.filter.fields.parker-dropdown-placeholder">
          </app-multi-select-filter>
        </div>
      </div>
      <div class="row">
        <div class="form-group col-12">
          <label class="control-label required">{{'i18n.domain.home.dashboard.shared.widgets.grid-rows' | translate}}</label>
          <ejs-dropdownlist [dataSource]="pageSizes"
                            id="pageSize"
                            formControlName="pageSize">
          </ejs-dropdownlist>
          <app-error-messages [control]="editSettingsForm.controls.pageSize"></app-error-messages>
        </div>
        <div class="form-group col-12">
          <div class="d-flex gap-1">
            <label class="control-label required">{{'i18n.domain.home.dashboard.shared.widgets.save-grid-filters' | translate}}</label>
            <ejs-tooltip id='tooltip' content="{{ 'i18n.domain.home.dashboard.shared.widgets.save-grid-filters-tooltip' | translate }}">
              <span class="icon-information"></span>
            </ejs-tooltip>
          </div>
          <app-yes-no-group-button id="saveGridFilters" [formControl]="editSettingsForm.controls.saveGridFilters"></app-yes-no-group-button>
        </div>
      </div>
    </form>
  </ng-template>
  <ng-template #footerTemplate>
    <button class="btn btn-primary"
            (click)="saveParameters()">
      {{'i18n.shared.ok' | translate}}
    </button>
  </ng-template>
</ejs-dialog>
